module.exports = __webpack_public_path__ + "static/media/snikre.cb48e18f.m4a";